import { Route, Routes } from "react-router-dom";
import MainLayout from "../layouts/MainLayout";
import Home from "../pages/home/Home";
import About from "../pages/about/About";
import Contact from "../pages/contact/Contact";
import Services from "../pages/services/Services";
import ServiceDetail from "../pages/services/ServiceDetail";
import Verification from "../pages/verification/Verification";
import VerificationSearch from "../pages/verification/VerificationSearch";
import Team from "../pages/team/Team";
import SubServices from "../pages/services/SubServices";
import EquipmentCertificate from "../pages/verification/EquipmentCertificate";
import IdCard from "../pages/verification/IdCard"
import Clients from "../pages/clients/Clients";
import ClientDetail from "../pages/clients/ClientDetail";
import OurProjects from "../pages/projects/OurProjects";
import ProjectDetail from "../pages/projects/ProjectDetail";

const AppRoutes = () => {
  return (
    <Routes>
      {/* AUTH ROUTES */}
      <Route element={<MainLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/services" element={<Services />} />
        <Route path="/sub-services" element={<SubServices />} />
        <Route path="/service-detail/:slug" element={<ServiceDetail />} />
        <Route path="/verification" element={<Verification />} />
        <Route path="/verification/:slug" element={<VerificationSearch />} />
        <Route path="/equipment-certificate" element={<EquipmentCertificate />} />
        <Route path="/id-card" element={<IdCard />} />
        <Route path="/team" element={<Team />} />
        <Route path="/clients" element={<Clients />} />
        <Route path="/clients/:slug" element={<ClientDetail />} />
        <Route path="/our-projects" element={<OurProjects />} />
        <Route path="/our-projects/:slug" element={<ProjectDetail />} />
      </Route>
    </Routes>
  );
};

export default AppRoutes;